<template>
  <div :class="grid">
    <q-card
      :class="gridType !== 'column' ? 'shadow-3' : 'shadow-3 h-150'"
      square
    >
      <div class="vehicle-container">
        <div class="vehicle-name">
          <div class="vehicle-brand">
            <span class="vehicle-span">Brand:</span>
            {{ vehicle.brand && vehicle.brand.name ? vehicle.brand.name : "" }}
          </div>
          <div>
            <q-btn flat rounded>
              <q-icon
                color="grey-7"
                size="15px"
                name="fas fa-ellipsis-h"
              ></q-icon>
              <q-menu content-class="text-grey-7" auto-close>
                <q-list style="min-width: 150px">
                  <q-item
                    clickable
                    v-for="(item, index) in vehicleActions"
                    :key="index"
                    @click="item.method(vehicle)"
                  >
                    <q-item-section>{{ item.name }}</q-item-section>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>
          </div>
        </div>
        <div class="vehicle-context">
          <div class="vehicle-model">
            <span
              class="vehicle-span"
              v-if="vehicle.model && vehicle.model.name"
              >Model:</span
            >
            {{ vehicle.model && vehicle.model.name ? vehicle.model.name : "" }}
          </div>
          <div class="vehicle-model">
            <span class="vehicle-span" v-if="vehicle.group_name">Group:</span>
            {{ vehicle.group_name }}
          </div>
          <div class="vehicle-year">
            <span class="vehicle-span" v-if="vehicle.model_year">Age:</span>
            {{ `${vehicle.model_year ? 2020 - vehicle.model_year : ""}` }}
          </div>
        </div>
        <div class="vehicle-context">
          <div class="vehicle-model">
            <span class="vehicle-span">VIN Number:</span>
            #{{ vehicle.vin }}
          </div>
          <div class="vehicle-model">
            <span class="vehicle-span">UNIT Number:</span>
            #{{ vehicle.unit }}
          </div>
        </div>
        <div
          class="vehicle-company-list"
          v-if="vehicle.location && vehicle.location.name"
        >
          <span class="vehicle-span">Location:</span>
          {{
            vehicle.location && vehicle.location.code
              ? vehicle.location.code
              : ""
          }}
        </div>
      </div>
    </q-card>
  </div>
</template>

<script>
import VehicleEdit from "./VehicleEdit";
import axios from "../axios/index";
export default {
  components: {
    VehicleEdit,
  },
  props: {
    vehicle: Object,
    index: Number,
  },
  data() {
    return {
      vehicleActions: [
        {
          name: "Delete",
          method: this.remove,
        },
        {
          name: "Edit",
          method: this.editFunc,
        },
      ],
    };
  },
  methods: {
    details(val) {},
    remove(val) {
      this.selectedVehicle = val;
      this.confirm = true;
    },
    async editFunc(val) {
      const { data } = await axios.get(`vehicle/${val.id}`);
      this.selectedVehicle = data;
      this.edit = true;
    },
    addToCompany(val) {},
  },
  computed: {
    gridType() {
      return this.$store.state.vehicle.grid;
    },
    grid: {
      get() {
        return this.$store.state.vehicle.grid === "row"
          ? "col-12"
          : "col-xl-6 col-lg-6 col-sm-12 col-xs-12 col-md-12";
      },
    },
    selectedVehicle: {
      get() {
        return this.$store.state.vehicle.selectedVehicle;
      },
      set(val) {
        this.$store.commit("vehicle/SET_SELECTED_VEHICLE", val);
      },
    },
    confirm: {
      get() {
        return this.$store.state.vehicle.confirm;
      },
      set(val) {
        this.$store.commit("vehicle/SET_CONFIRM", val);
      },
    },
    operation: {
      get() {
        return this.$store.state.vehicle.operation;
      },
      set(val) {
        this.$store.commit("vehicle/SET_VEHICLE_OPERATION", val);
      },
    },
    edit: {
      get() {
        return this.$store.state.vehicle.edit;
      },
      set(val) {
        this.$store.commit("vehicle/SET_EDIT", val);
      },
    },
  },
};
</script>
